import { eventsSenderYandex } from 'globalState/global-state.js';

export const buttonFind = (query: string) => {
    try {
        eventsSenderYandex('search', 'button_find', { query, split: window.config.state.split });
    } catch (error) {
        console.error('Error sending event:', error);
    }
};

export const emptyResult = ({ query, source }: { query: string, source: string }) => {
    try {
        eventsSenderYandex('search', 'empty_result', { query, source, split: window.config.state.split });
    } catch (error) {
        console.error('Error sending event:', error);
    }
};

export const showAnalogs = ({ query, source }: { query: string, source: string }) => {
    try {
        eventsSenderYandex('search', 'show_analogs', { query, source, split: window.config.state.split });
    } catch (error) {
        console.error('Error sending event:', error);
    }
};

